<template>
  <div class="custom-container" v-loading.fullscreen.lock="category.isLoading">
    <el-row type="flex" align="center" class="my-4" justify="space-between">
      <el-col :span="5">
        <div class="category-title">Create Category</div>
      </el-col>
      <el-col :span="4">
        <el-row type="flex" justify="end">
          <el-button size="small" @click="$router.go(-1)">Kembali</el-button>
          <el-button size="small" type="primary" @click="save">Simpan</el-button>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form label-position="left" ref="formCategory" label-width="150px" :model="formCategory">
          <Form :Category="formCategory"></Form>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Form from "./Form";
import { mapActions, mapState } from "vuex";
export default {
  components: {
    Form
  },
  data: () => ({
    formCategory: {
      kategoriCode: "",
      kategoriLevel: 0,
      description: "",
      picture: '',
      thumbnail: ''
    },
    valid: true,
    draft: false
  }),
  computed: {
    ...mapState({
      category: state => state.category.category
    })
  },
  methods: {
    ...mapActions({
      createCategory: "category/CreateCategory"
    }),
    save() {
      this.$refs.formCategory.validate(valid => {
        if (valid) {
          this.createCategory(this.formCategory);
          this.snackbar = true;
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style>
</style>
